<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="TimeRangeStatistics"
      icon="mdi-cards"
    >
      <template #footer="{tableItems}">
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="download(tableItems)"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('export') }}
        </v-btn>
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import hourlyReport from '@/model/dataLayer/api/statistic/hourlyReport'
import FileSaver from 'file-saver'

export default {
  name: 'HourlyReport',
  components: {
    IkDataTable
  },
  data () {
    return {
      model: hourlyReport
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async download (items) {
      console.log(items, 'item')
      let dataStrings = ['起始时间,结束时间,销售数量,税率,总订单数量,订单完成数量,总金额']
      items.forEach((it) => {
        it.taxes = it.taxes.replace(',', '.')
        const res = [
          it.startsAt,
          it.endsAt,
          it.sumDODCount,
          it.taxes,
          it.openCount,
          it.closedCount,
          it.sumTotal
        ]
        dataStrings.push(res.join())
      })
      dataStrings = dataStrings.join('\n')
      const blob = new Blob([dataStrings], { type: 'text/plain;charset=utf-8' })
      FileSaver.saveAs(blob, '时段统计.csv')
    }
  }
}
</script>

<style scoped>

</style>
